<script>
import SortableTable from "@components/SortableTable.vue";
import api from "@services/api";
export default {
  extends: SortableTable,
  components: {},
  props: {
    table: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    fields: {
      type: Array,
      default: () => {
        return [];
      }
    },
    filter: {
      type: String,
      default: ""
    },
    include: {
      type: String,
      default: ""
    },
    lista: {
      type: Array,
      default: () => {
        return [];
      }
    },
    tipo: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    items: null,
    empty: true,
    page: 1,
    totalRows: 1,
    size: 20,
    sort: {
      sortBy: "id",
      sortOrder: "ASC"
    },
    hasItems: true,
    itemRemove: null,
    showModalEditCod: false,
    codigoAtual: null,
    itemSelected: null
  }),
  computed: {
    listaRetorno() {
      return this.lista;
    }
  },
  created() {},
  methods: {
    remove(val) {
      this.$emit("delete-table", val);
    },
    selectedCheck(item) {
      if (item.tem === true) {
        this.$emit("add-table", item.grupoItemId, item.usuarioId);
      } else {
        this.remove(item.grupoItemUsuarioId);
      }
    },
    closeModal() {
      this.showModalEditCod = false;
      this.codigoAtual = "";
    },
    openModal(item) {
      this.showModalEditCod = true;
      this.itemSelected = item;
      this.codigoAtual = item.codigo;
    },
    salvarCodigo() {
      let formData = new FormData();
      formData.append("codigo", this.codigoAtual);
      formData.append(
        "grupoItemUsuarioId",
        this.itemSelected.grupoItemUsuarioId
      );

      api.post(`crud/grupo/atualizarCodigo`, formData).then(response => {
        if (response.data["status"].toLowerCase() == "success") {
          this.hasSuccess = true;
          this.$emit("update-table");
          this.closeModal();
        }
      });
    }
  },
  watch: {
    lista: function() {
      this.items = this.lista;

      if (this.items.length > 0) {
        this.hasItems = true;
      } else {
        this.hasItems = false;
      }
    }
  }
};
</script>

<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="row mt-5 mb-2" v-show="!hasItems">
          <div class="col-md-12">Não foram encontrados registros.</div>
        </div>
        <div class="table-sm table " v-show="hasItems">
          <table class="table b-table table table-hover">
            <thead class="thead-primary">
              <tr>
                <th
                  class="columnheader"
                  scope="col"
                  @click="
                    changeSort(field.sortName, field.name, field.sortable)
                  "
                  v-for="field in fields"
                  :key="field.name + '.' + field.type"
                >
                  {{ field.description }}
                  <i
                    class="fas fa-sort-down ml-2"
                    v-show="
                      showSortDown(field.sortName, field.name, field.sortable)
                    "
                  />
                  <i
                    class="fas fa-sort-up ml-2"
                    v-show="
                      showSortUp(field.sortName, field.name, field.sortable)
                    "
                  />
                  <i
                    class="fas fa-sort ml-2"
                    style="color: lightgray"
                    v-show="
                      showSortNone(field.sortName, field.name, field.sortable)
                    "
                  />
                </th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody v-if="tipo !== 'USUÁRIO'" class="selected-table">
              <tr v-for="item in items" :key="item.id">
                <td
                  v-for="field in fields"
                  :key="field.name + '.' + field.type"
                  @click="callDetails(item.id)"
                >
                  {{ item[field.name] | formatField(field.type) }}
                </td>

                <td width="40%">
                  <div class="float-left">
                    <b-form-checkbox
                      v-model="item.tem"
                      @change="selectedCheck(item)"
                    >
                    </b-form-checkbox>
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody v-if="tipo === 'USUÁRIO'" class="selected-table">
              <tr v-for="item in items" :key="item.id">
                <td
                  v-for="field in fields"
                  :key="field.name + '.' + field.type"
                  @click="callDetails(item.id)"
                >
                  {{ item[field.name] | formatField(field.type) }}
                </td>
                <td width="20%">
                  <div class="float-left">
                    <b-button
                      class="btn btn-icon ml-1"
                      variant="primary"
                      v-b-tooltip.hover
                      title="Editar Código"
                      v-on:click="openModal(item)"
                      :disabled="item.grupoItemUsuarioId == null"
                    >
                      <i class="fe-edit"></i>
                    </b-button>
                  </div>
                </td>
                <td width="40%">
                  <b-form-checkbox
                    v-model="item.tem"
                    @change="selectedCheck(item)"
                  >
                  </b-form-checkbox>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="row" v-show="totalRows > 10">
            <div class="col-md-9 mt-1">
              <b-pagination
                v-model="page"
                pills
                :total-rows="totalRows"
                :per-page="size"
              />
            </div>
            <div class="col-md-3">
              <b-form-group
                id="size"
                label-cols-lg="7"
                label="Registros por página:"
              >
                <b-form-select v-model="size">
                  <b-form-select-option value="10">10</b-form-select-option>
                  <b-form-select-option value="20">20</b-form-select-option>
                  <b-form-select-option value="50">50</b-form-select-option>
                  <b-form-select-option value="100">100</b-form-select-option>
                </b-form-select>
              </b-form-group>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      @close="closeModal"
      @change="closeModal"
      v-model="showModalEditCod"
      title="Editar Código"
      centered
      hide-footer
    >
      <div class="button-list text-right">
        <b-form @submit.prevent="salvarCodigo">
          <b-form-group
            id="input-group-1"
            label="Código"
            label-for="codigo"
            class="col-md-12 text-left"
          >
            <b-form-input
              id="codigo"
              type="text"
              :value="codigoAtual"
              v-model="codigoAtual"
              required
              autocomplete="off"
            ></b-form-input>
          </b-form-group>
          <b-button class="btn btn btn-icon" variant="light" @click="closeModal"
            >Cancelar</b-button
          >
          <b-button class="btn btn btn-icon" variant="primary" type="submit"
            >Salvar</b-button
          >
        </b-form>
      </div>
    </b-modal>
  </div>
</template>
